import CheckIcon from "@mui/icons-material/Check";
import { Button } from "@mui/material";
import Flex from "@/components/Flex";
import { NOTE_PREVIEW_LABELS } from "../note-preview-constant";

export interface CosignActionsProps {
  isEditingNote: boolean;
  isSubmitting?: boolean;
  onCancel: () => void;
  onEditNote: () => void;
  onSubmit: () => void;
}

const CosignActions = ({
  isEditingNote,
  isSubmitting,
  onCancel,
  onEditNote,
  onSubmit,
}: CosignActionsProps) => (
  <Flex gap={1} justifyContent="flex-end" width="100%">
    <Button variant="text" onClick={onCancel} disabled={isSubmitting}>
      {NOTE_PREVIEW_LABELS.cancel}
    </Button>
    {!isEditingNote && (
      <Button variant="outlined" onClick={onEditNote} disabled={isSubmitting}>
        {NOTE_PREVIEW_LABELS.editNote}
      </Button>
    )}
    <Button
      variant="contained"
      startIcon={<CheckIcon />}
      onClick={onSubmit}
      disabled={isSubmitting}
    >
      {NOTE_PREVIEW_LABELS.saveAndCoSign}
    </Button>
  </Flex>
);

export default CosignActions;
